import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_box_set_item = _resolveComponent("product-box-set-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-box-set-list", 'product-box-set-list--items_' + _ctx.listItems.length])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems, (product, index) => {
      return (_openBlock(), _createBlock(_component_product_box_set_item, {
        class: "product-box-slider__item",
        key: product.id,
        "product-box-data": product,
        "hide-counter-button": _ctx.hideCartButton,
        "hide-quickfacts": _ctx.hideQuickfacts,
        "show-quickfacts-with-desc": _ctx.showQuickfactsWithDesc,
        state: _ctx.getProductState(product),
        "tracking-additional": {
        position: index,
        list: _ctx.trackingList
      },
        onAddToBasket: _ctx.addToBasketHandler,
        onQuantityChange: _ctx.quantityChangeHandler,
        onAddToWishlist: _ctx.addToWishlistHandler,
        onRemoveFromWishlist: _ctx.removeFromWishlistHandler
      }, null, 8 /* PROPS */, ["product-box-data", "hide-counter-button", "hide-quickfacts", "show-quickfacts-with-desc", "state", "tracking-additional", "onAddToBasket", "onQuantityChange", "onAddToWishlist", "onRemoveFromWishlist"]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}